import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from "@angular/core";
import { DashboardExportSummaryResponseDto } from "src/app/shared/dto";
import { AccountAttributesEnum, DashboardExportsSummaryTypeEnum } from "src/app/shared/enums";

@Component({
    selector: 'app-exports-card',
    templateUrl: './exports-card.component.html',
    styleUrls: ['../../common-reporting-dashboard.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})

export class ExportsCardComponent {
    @Input() isLoading: boolean;
    @Input() useLargeText: boolean = false;
    @Input() set exportsData(value: DashboardExportSummaryResponseDto) {
        if (value) {
          this.innerExportsData = value;
        }
      }
    @Output() sendEvent = new EventEmitter<string>();

      get exportsData(): DashboardExportSummaryResponseDto {
        return this.innerExportsData;
      }

      selectedOption: string = 'All';
      accountAttributesEnum: typeof AccountAttributesEnum = AccountAttributesEnum;
      readonly exportsSummaryEnum: typeof DashboardExportsSummaryTypeEnum = DashboardExportsSummaryTypeEnum;
      private innerExportsData: DashboardExportSummaryResponseDto;

      updateSelectedOption(option: string, enumVal?: DashboardExportsSummaryTypeEnum) {
        this.selectedOption = option;
        this.sendEvent.emit(enumVal);
      }
}
